<div class="lineBlock">
    <canvas id="myChart" height="100" class="highWidth"></canvas>
</div>